// One-way migration: purge the deprecated Tier Builder localStorage keys.
//
// Before the display-tier rewrite, the Tier Builder wrote userTierSheet /
// userTierOrder / userTierNames (per-league, suffixed "_<league>"). Those keys
// are ALSO read by the price engine (useLeagueSettings -> usePricing.js:205)
// and the mock-draft AI tier sheets (simulation.js:196), so any leftover values
// are orphaned "ghost" drags that would silently keep skewing prices.
// userTierCount backed the short-lived tier-count stepper (since removed) and
// is likewise dead. The Tier Builder now persists only to userDisplayTier*.
// Pre-launch there is nothing worth preserving, so we hard-clear these on every
// load, before React reads them.
//
// Touches ONLY these deprecated key families. The new display keys
// (userDisplayTierMoves/Order/Names) and TIER_MAPS are untouched.
const DEPRECATED_TIER_KEY_BASES = ["userTierSheet", "userTierOrder", "userTierNames", "userTierCount"];

export function clearDeprecatedTierKeys() {
  try {
    const toRemove = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (!k) continue;
      // Match the bare base or any per-league variant ("base_<league>").
      if (DEPRECATED_TIER_KEY_BASES.some(base => k === base || k.startsWith(base + "_"))) {
        toRemove.push(k);
      }
    }
    toRemove.forEach(k => localStorage.removeItem(k));
  } catch { /* ignore (private mode / unavailable storage) */ }
}
